// extracted by mini-css-extract-plugin
export default {"buttonHeader":"styles-module--buttonHeader--27gdo","primaryButton":"styles-module--primaryButton--64Scg","secundaryButton":"styles-module--secundaryButton--2EEti"};